export default "__VITE_ASSET__aQ$AwsZ5__"